/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import GridContainer from "@insite/mobius/GridContainer/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import { useWORContext } from "@tKgpco/Widgets/WOR/WORCheckoutReviewSubmitPage";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

const WORSpecialDeliveryInstructions: React.FunctionComponent<Props> = ({ fields }: Props) => {
    const { worData, worDispatch } = useWORContext();
    return (
        <GridContainer
            css={css`
                margin-top: 1.5rem;
            `}
        >
            <GridItem
                width={12}
                css={css`
                    padding-bottom: 0;
                `}
            >
                <Typography as="h3" variant="h5" size="14px">
                    Special Delivery Instructions
                </Typography>
            </GridItem>
            <GridItem
                width={[12, 12, 6, 6, 6]}
                css={css`
                    padding-top: 0.275rem;
                `}
            >
                <CheckboxGroup>
                    <Checkbox
                        labelPosition="right"
                        checked={worData.callTag}
                        onChange={(e, val) => worDispatch({ type: "SET_DATA", payload: { callTag: val } })}
                    >
                        {translate("Call Tag")}
                    </Checkbox>
                </CheckboxGroup>
            </GridItem>
            <GridItem
                width={[12, 12, 6, 6, 6]}
                css={css`
                    padding-top: 0.275rem;
                `}
            >
                <CheckboxGroup>
                    <Checkbox
                        labelPosition="right"
                        checked={worData.certifiedMail}
                        onChange={(e, val) => worDispatch({ type: "SET_DATA", payload: { certifiedMail: val } })}
                    >
                        {translate("Certified Mail")}
                    </Checkbox>
                </CheckboxGroup>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: WORSpecialDeliveryInstructions,
    definition: {
        displayName: "WOR Checkout Special Delivery Instructions",
        group: "Checkout - Review & Submit",
    },
};

export default widgetModule;
